export default __webpack_public_path__ + "static/media/Antiques.0caaed3f.jpeg";